export const prepDataSource = [
  { id: 1, name: "Print Ready PDF", displayExpr: "Print Ready PDF" },
  { id: 2, name: "Application Files", displayExpr: "Application Files" },
];

export const proofTextDataSource = [
  {
    id: 1,
    name: "Soft proofs - for content and color break",
    displayExpr: "Soft proofs - for content and color break",
  },
  {
    id: 2,
    name: "Lasers - for content and color break",
    displayExpr: "Lasers - for content and color break",
  },
  { id: 3, name: "Epson's - for color", displayExpr: "Epson's - for color" },
];

export const paperTextDataSource = [{ id: 1, name: "tbd", displayExpr: "tbd" }];

export const printTextDataSource = [
  { id: 1, name: "1/1 text, no bleeds", displayExpr: "1/1 text, no bleeds" },
  {
    id: 2,
    name: "1/1 text, with bleeds",
    isGroup: true,
    displayExpr: "1/1 text, with bleeds",
  },
  {
    id: 3,
    name: "Head Bleeds",
    categoryId: 2,
    displayExpr: "1/1 text, with bleeds; Head Bleeds",
  },
  {
    id: 4,
    name: "Foot Bleeds",
    categoryId: 2,
    displayExpr: "1/1 text, with bleeds; Foot Bleeds",
  },
  {
    id: 5,
    name: "Face Trim Bleeds",
    categoryId: 2,
    displayExpr: "1/1 text, with bleeds; Face Trim Bleeds",
  },
  {
    id: 6,
    name: "Gutter Bleeds",
    categoryId: 2,
    displayExpr: "1/1 text, with bleeds; Gutter Bleeds",
  },
];

export const bindDataSource = [
  { id: 1, name: "Adhesive Bind", displayExpr: "Adhesive Bind" },
];

export const caseStyleDataSource = [
  {
    id: 1,
    name: "1 Piece case",
    isGroup: true,
    displayExpr: "1 Piece case",
  },
  {
    id: 2,
    name: "Add free text field for case material",
    categoryId: 1,
    displayExpr: "1 Piece case; Add free text field for case material",
  },
  {
    id: 3,
    name: "3-piece case",
    isGroup: true,
    displayExpr: "3-piece case",
  },
  {
    id: 4,
    name: "Sides over spine",
    categoryId: 3,
    displayExpr: "3-piece case; Sides over spine",
  },
  {
    id: 5,
    name: "Spine over sides",
    categoryId: 3,
    displayExpr: "3-piece case; Spine over sides",
  },
  {
    id: 6,
    name: "Foil Stamp",
    isGroup: true,
    displayExpr: "Foil Stamp",
  },
  {
    id: 7,
    name: "Spine only",
    categoryId: 6,
    requiresInput: true,
    requiresCaseSize: true,
    displayExpr: "Foil Stamp; Spine only",
    //Size:
  },
  {
    id: 9,
    name: "Front cover and Spine",
    categoryId: 6,
    requiresInput: true,
    requiresFrontAndSpineSize: true,
    displayExpr: "Foil Stamp; Front cover and Spine",
    //Front size:, Spine size:
  },
  {
    id: 12,
    name: "Blind Embossing on Case",
    isGroup: true,
    displayExpr: "Blind Embossing on Case",
  },
  {
    id: 13,
    name: "Front Cover",
    categoryId: 12,
    requiresInput: true,
    requiresCaseSize: true,
    displayExpr: "Blind Embossing on Case; Front Cover",
    //"Size:",
  },
];

export const boardsDataSource = [{ id: 1, name: "tbd", displayExpr: "tbd" }];

export const endpapersDataSource = [
  {
    id: 1,
    name: "No",
    displayExpr: "No",
  },
  {
    id: 2,
    name: "Yes",
    requiresInput: true,
    displayExpr: "Yes",
    //Weight:, Color:
  },
];

export const headFootDataSource = [
  { id: 1, name: "Color", displayExpr: "Color" },
];

export const packDataSource = [
  {
    id: 1,
    name: "Cartons: single walled",
    displayExpr: "Cartons: single walled",
  },
  {
    id: 2,
    name: "Cartons: double walled",
    isGroup: true,
    displayExpr: "Cartons: double walled",
  },
  {
    id: 3,
    name: "Carton pack",
    categoryId: 2,
    isGroup: true,
    displayExpr: "Cartons: double walled, Carton pack",
  },
  {
    id: 4,
    name: "Pallets: Customer Furnished",
    categoryId: 3,
    displayExpr:
      "Cartons: double walled, Carton pack, Pallets: Customer Furnished",
  },
  {
    id: 5,
    name: "Pallets: BPG Furnished",
    categoryId: 3,
    displayExpr: "Cartons: double walled, Carton pack, Pallets: BPG Furnished",
  },
];

export const shipmentDataSource = [
  { id: 1, name: "No", displayExpr: "No" },
  { id: 2, name: "Yes", displayExpr: "Yes", requiresInput: true },
  //Amount:
];
